export const PHOTO_GUIDE_QUERY_PARAM_KEY = 'photo-guide'
